module.exports = __webpack_public_path__ + "static/media/ic_fillter.b5e5edfd.png";